module.exports = __webpack_public_path__ + "media/images/flags/tl-b96718d8bf56637f41c24b46a34b4a68.svg";